import {
	NotificationOutlined,
	TeamOutlined,
	UserAddOutlined,
} from '@ant-design/icons';
import { Button, Flex, Rate, Tooltip, Typography, notification } from 'antd';
import cn from 'classnames';

import placeholderImg from '@/lib/assets/placeholder.jpg';
import { formatNumber } from '@/lib/helpers/formatNumber';
import prepareImageSrc from '@/lib/helpers/prepareImageSrc';

import styles from '../../styles.module.css';

import { TActiveMenuTab } from '../..';
import { mockData2 } from '../data';

type TProps = {
	activeTab: TActiveMenuTab;
	item: any;
	onClose: () => void;
};

type TCreatorData = typeof mockData2.content.creator;

export default function CreatorInsights({ activeTab, item, onClose }: TProps) {
	const platformData: any =
		Object.values(item?.content?.creator?.platforms ?? {})?.filter(
			(i) => !!i,
		)?.[0] || null;
	const postsAmount = formatNumber(platformData?.posts?.posts ?? 0);

	const followersAmount = formatNumber(
		(platformData?.connections?.followers ||
			platformData?.connections?.subscribers) ??
			0,
	);
	const followingAmount = formatNumber(
		platformData?.connections?.following ?? 0,
	);

	if (activeTab !== 'creator-insight') {
		return null;
	}

	const creator = item?.content?.creator;
	const creatorUrl =
		creator?.platformHandles?.[1] || creator?.platformHandles?.[0] || '';

	return (
		<Flex vertical gap={4} align="flex-start">
			{
				<>
					<Flex
						style={{ width: '100%', marginBottom: '1rem' }}
						justify="space-between"
						align="center"
					>
						<Flex gap={8} align="center">
							{creator?.profileImageURL ? (
								<img
									src={prepareImageSrc(creator?.profileImageURL)}
									alt={creator?.profileName}
									className={styles.thumbnail}
									width={100}
									height={100}
									onError={(e) => {
										// @ts-ignore
										e.target.src = placeholderImg; // Fallback image
									}}
								/>
							) : (
								<img
									src={placeholderImg}
									width={130}
									height={124}
									className={styles.thumbnail}
								/>
							)}

							{/* <Flex vertical gap={4} style={{ width: "100%" }}> */}
							{/* <Typography.Text>
            <b>Name:</b> {data?.creator?.profileName}
          </Typography.Text> */}

							{creatorUrl ? (
								<Tooltip title={creator?.profileName}>
									<Button
										type="link"
										size="large"
										href={creatorUrl}
										target="_blank"
										style={{
											width: 'fit-content',
											fontSize: '18px',
											display: 'flex',
											wordWrap: 'break-word',
											// overflow: 'hidden',
											padding: '2px',
										}}
									>
										<span
											style={{
												width: '100%',
												fontSize: '18px',
												display: 'inline-block',
												// overflow: 'hidden',
												// textOverflow: 'ellipsis',
											}}
										>
											{creator?.profileName}
										</span>
									</Button>
								</Tooltip>
							) : (
								<Tooltip title={creator?.profileName}>
									<Typography.Text
										style={{
											width: 'fit-content',
											fontSize: '18px',
											display: 'inline-block',
											overflow: 'hidden',
											textOverflow: 'ellipsis',
										}}
									>
										{platformData?.username}
									</Typography.Text>
								</Tooltip>
							)}
							{/* </Flex> */}
						</Flex>

						{/* <Tooltip title="Integrity Report">
								<Button
									onClick={onIntegrityReportClick}
									style={{ height: 'fit-content', maxHeight: 'unset' }}
								>
									<Flex
										style={{ width: '100%', cursor: 'pointer' }}
										gap={4}
										align="center"
										justify="space-between"
									>
										<img
											src={integrityReportImg}
											alt=""
											style={{ height: '32px', width: '32px' }}
											height={32}
											width={32}
										/>

										<Flex vertical style={{ maxWidth: '100px' }} align="center">
											<Typography.Text style={{ fontSize: '12px' }}>
												Integrity Report
											</Typography.Text>
											<Rate
												defaultValue={4}
												disabled
												style={{ transform: 'scale(0.5)' }}
											/>
										</Flex>
									</Flex>
								</Button>
							</Tooltip> */}
					</Flex>
					{platformData && (
						<>
							<Typography.Text
								title={`${
									platformData?.connections?.followers ||
									platformData?.connections?.subscribers
								} followers`}
							>
								<TeamOutlined className={styles.amountItemIcon} />
								<span className={styles.amountItem}>
									{followersAmount}
								</span>{' '}
								<small>followers</small>
							</Typography.Text>

							{platformData?.connections?.following && (
								<Typography.Text
									title={`${platformData?.connections?.following} posts`}
								>
									<UserAddOutlined className={styles.amountItemIcon} />
									<span className={styles.amountItem}>
										{followingAmount}
									</span>{' '}
									<small>following</small>
								</Typography.Text>
							)}

							{platformData?.posts?.posts && (
								<Typography.Text title={`${platformData?.posts?.posts} posts`}>
									<NotificationOutlined className={styles.amountItemIcon} />
									<span className={styles.amountItem}>{postsAmount}</span>{' '}
									<small>posts</small>
								</Typography.Text>
							)}
						</>
					)}

					<Typography.Title
						level={4}
						className={cn(styles.tabTitle, styles.underline, styles.mt2)}
					>
						Self introduction
					</Typography.Title>

					{platformData?.description && (
						<Typography.Text>{platformData?.description}</Typography.Text>
					)}

					{platformData?.about &&
						platformData?.about !== platformData?.description && (
							<Typography.Text>{platformData?.about}</Typography.Text>
						)}
				</>
			}
		</Flex>
	);
}
